import styled from 'styled-components'

import { ClinTheme } from '../../ClinTheme'
import { ClinButton } from '../../components/ClinButton'

interface IStyledIconProps {
  height?: number
  width?: number
}

export const StyledCheckoutDrawer = styled.div({
  padding: `0 ${ClinTheme.space[5]}px`,
  height: 'calc(100% - 48px)',
  overflow: 'auto',
  [`.clin-announce`]: {
    marginBottom: ClinTheme.space[3]
  }
})

export const StyledDrawerHeader = styled.div({
  marginBottom: ClinTheme.space[3]
})

export const StyledDrawerBody = styled.div({
  marginBottom: ClinTheme.space[5]
})

export const StyledDeliveryAddressWrap = styled.div({})

export const StyledDeliveryAddressCheckoutWrapper = styled.div({
  marginBottom: 0,
  marginTop: 0,
  padding: 0
})

export const StyledEstimatedDeliveryDate = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: `${ClinTheme.space[2]}px ${ClinTheme.space[3]}px`,
  marginBottom: ClinTheme.space[2],
  backgroundColor: ClinTheme.colors.deliveryDateBackground,
  borderRadius: ClinTheme.space[2]
})

export const StyledEstimatedDeliveryText = styled.div({
  marginLeft: ClinTheme.space[3],
  width: '100%'
})

// Override the TableContainer to remove scrollbars
export const StyledTableContainer = styled.div({
  display: 'table',
  width: '100%',
  overflow: 'hidden'
})

export const StyledNewCheckoutBlock = styled.div({
  display: 'flex',
  flexDirection: 'column',
  borderRadius: ClinTheme.radii[3],
  background: ClinTheme.colors.greyIndigo,
  padding: ClinTheme.space[3]
})

export const StyledCheckoutTextareaContainer = styled.div({
  width: '100%'
})

export const StyledNewCheckoutBlockHeader = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingBottom: ClinTheme.space[2]
})

export const StyledNewCheckoutBlockBody = styled.div({
  paddingBottom: ClinTheme.space[4]
})

export const StyledNewCheckoutAdditionalBlock = styled.div({
  paddingTop: ClinTheme.space[4],
  paddingBottom: ClinTheme.space[3]
})

export const StyledCheckoutDeliveryDateContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginTop: ClinTheme.space[5],
  background: ClinTheme.colors.deliveryDateBackground,
  padding: ClinTheme.space[3],
  borderRadius: ClinTheme.radii[2]
})

export const StyledCheckoutDeliveryDateIconContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: ClinTheme.space[3]
})

export const StyledCheckoutPoBlock = styled.div({
  display: 'flex',
  flexDirection: 'column',
  padding: ClinTheme.space[3],
  background: ClinTheme.colors.pastelLavender,
  borderRadius: ClinTheme.radii[3]
})

export const StyledCheckoutDeliveryDateContent = styled.div({
  display: 'flex',
  flexDirection: 'column'
})

export const StyledNewCheckoutUserInfoBlock = styled.div({})

export const StyledDeclarationCheckoutBlockBody = styled.div({
  flex: '0 0 100%',
  paddingTop: ClinTheme.space[3],
  paddingBottom: ClinTheme.space[5],
  background: ClinTheme.colors.white
})

export const StyledSafetyCheckoutBlockBody = styled.div({
  flex: '0 0 100%',
  paddingTop: ClinTheme.space[3],
  paddingBottom: ClinTheme.space[2],
  background: ClinTheme.colors.white
})

export const StyledClinButtonPrimary = styled(ClinButton)({
  fontSize: ClinTheme.fontSizes[2]
})

export const StyledClinButton = styled(ClinButton)({
  fontSize: ClinTheme.fontSizes[2],
  color: ClinTheme.colors.black
})

export const StyledSpinnerContainer = styled.div({
  display: 'flex',
  height: '50vh',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  gap: '16px'
})

export const StyledButtonSection = styled.div({
  display: 'flex',
  gap: '16px',
  flexDirection: 'column'
})

export const StyledButtonSection2 = styled.div({
  display: 'flex',
  gap: '8px',
  flexDirection: 'row',
  alignItems: 'flex-end'
})

export const StyledAnnounceBarContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: '8px',
  gap: '8px'
})

export const StyledSummaryOneStepCheckout = styled.div({
  display: 'flex',
  flexDirection: 'column'
})

export const StyledRow = styled.div({
  display: 'flex',
  gap: '4px',
  flexWrap: 'wrap',
  alignItems: 'flex-start'
})

export const StyledIcon = styled.img<IStyledIconProps>(
  {
    objectFit: 'contain',
    objectPosition: 'left'
  },
  ({ height, width }: IStyledIconProps) => ({
    height: height ? `${height}px` : '20px',
    width: width ? `${width}px` : '27px'
  })
)

export const StyledClinButtonEdit = styled(ClinButton)({
  padding: '12px',
  borderRadius: '50%',
  border: 'none',

  '&:focus, &:hover': {
    boxShadow: 'none',
    backgroundColor: 'rgba(0,0,0,0.04)'
  }
})

export const StyledClinButtonLink = styled(ClinButton)({
  fontWeight: ClinTheme.fontWeights.normal,
  fontSize: ClinTheme.fontSizes[0],
  color: ClinTheme.colors.vibrantBlue,
  height: 'auto',
  cursor: 'pointer',

  '&:focus, &:hover, &:active': {
    textDecoration: 'none',
    color: ClinTheme.colors.vibrantBlue
  }
})
